export default __webpack_public_path__ + "static/media/864.6cd825c4.png";